export const EVENT_INITIATORS = {
    USER: 'user',
    SYSTEM: 'system',
};
export const INTERACTION_TYPES = {
    CLICK: 'click',
    HOVER: 'hover',
    LOAD: 'load',
    SCROLL: 'scroll',
    SELECT: 'select',
    TYPE: 'type',
    UPDATE: 'update',
    VIEW: 'view',
};
